import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    contract_detail,
    outsource_contract_detail,
    placing_ads_record_select_search,
    placing_ads_vas_record_select_search,
    expense_group_import_expense
 } = util.api || {}

export function getContractDetailApi(params) {
    return http.get(contract_detail, params);
}

export function getPlacingAdsRecordApi(params) {
    return http.get(placing_ads_record_select_search, params);
}

export function getPlacingAdsVasRecordApi(params) {
    return http.get(placing_ads_vas_record_select_search, params);
}

export function getOutsourceContractDetailApi(params) {
    return http.get(outsource_contract_detail, params);
}

export function importDataApi(params) {
    return http.post_upload(expense_group_import_expense, params)
}